module.exports = __webpack_public_path__ + "static/img/a051.2db7a4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a051.jpg
// module id = ozkn
// module chunks = 0